import React from 'react'

export const useAddConsentEventsListenersHook = (
  handleInitialUserConsent: (e: Event | CustomEvent<Record<string, boolean>>) => void,
  handleExistingUserConsent: () => void
) => {
  React.useEffect(() => {
    window.addEventListener('cf_init', handleExistingUserConsent)
    window.addEventListener('cf_services_consent', handleInitialUserConsent)
    return () => {
      window.removeEventListener('cf_services_consent', handleInitialUserConsent)
      window.removeEventListener('cf_init', handleExistingUserConsent)
    }
  }, [handleInitialUserConsent, handleExistingUserConsent])
}
